export default __webpack_public_path__ + "static/media/house.951611a0.png";